function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import moment from "moment";
import { range } from "lodash-es";
import { getDaysInMonth } from "date-fns";
var MONTHS = range(0, 12).map(function (month) {
  return {
    month: moment().month(month).format("MMM").toUpperCase(),
    number: month
  };
});
function isValidInteger(value) {
  // eslint-disable-next-line no-param-reassign
  if (typeof value === "string") value = Number(value);
  return Number.isInteger(value);
}
function inferMonth(string, date) {
  if (string === undefined) return date.getMonth();
  if (isValidInteger(string)) {
    var _month = Number(string) - 1;
    if (_month < 0 || _month > 11) return date.getMonth();
    return _month;
  }
  // eslint-disable-next-line no-param-reassign
  string = string.substring(0, 3).toUpperCase();
  var _MONTHS$filter = MONTHS.filter(function (_ref) {
      var month = _ref.month;
      return month.startsWith(string);
    }),
    _MONTHS$filter2 = _slicedToArray(_MONTHS$filter, 1),
    month = _MONTHS$filter2[0];
  if (month === undefined) return date.getMonth();
  return month.number;
}
function inferDay(string, date) {
  if (string === undefined) return date.getDate();
  var day = Number(string);
  if (!isValidInteger(day) || day < 1 || day > getDaysInMonth(date)) {
    return date.getDate();
  }
  return day;
}
function inferYear(string, date) {
  if (string === undefined) return date.getFullYear();
  var digits = string.trim().length;
  var year = Number(string);
  if (!isValidInteger(year) || year < 0) {
    return date.getFullYear();
  }
  switch (digits) {
    case 2:
      if (year < 50) {
        return 2000 + year;
      }
      return 1900 + year;
    case 4:
      return year;
    default:
      return date.getFullYear();
  }
}
function inferMinutes(string, date) {
  if (string === undefined) return date.getMinutes();
  var minutes = Number(string);
  if (!isValidInteger(minutes) || minutes < 0 || minutes > 60) {
    return date.getMinutes();
  }
  return minutes;
}
function inferHours(string, isPm, date) {
  if (string === undefined) return date.getHours();
  var hours = Number(string);
  if (!isValidInteger(hours) || hours < 0 || hours > 23) {
    return date.getHours();
  }
  if (!isPm && hours === 12) return 0;
  return isPm && hours < 12 ? hours + 12 : hours;
}
function isPm(string, hours) {
  // eslint-disable-next-line no-param-reassign
  string = (string || "").toUpperCase();
  if (string === "PM" || string === "P") return true;
  if (string === "AM" || string === "A") return false;
  if (isValidInteger(hours)) {
    var hoursNumber = Number(hours);
    if (hoursNumber >= 1 && hoursNumber <= 4) return true;
  }
  return false;
}
function getDateFromOnlyNumber(value) {
  var dateFormat = /^(\d{1,2})[\ ]*(\d{1,2})[\ ]*(\d{4}|\d{1,2})*$/i;
  if (value.length === 2) {
    dateFormat = /^(\d{2})()()$/;
  }
  return value.match(dateFormat);
}
function getDateFromMonthStr(value) {
  var dateFormat = /^([a-z]+)[\ ]*([1][0-9]|2[0-9]|3[01]|0?[1-9])*[\,*\ +]*(\d{4}|\d{2})*$/i;
  return value.match(dateFormat);
}
function getDateFromGeneral(value) {
  var dateFormat = /^([1][0-9]|2[0-9]|3[01]|0?[1-9]+)[\:](0?[1-9]|1[012])[\ ]*([ap]+m*)*$/i;
  return value.match(dateFormat);
}
function getDate(value) {
  var values = getDateFromOnlyNumber(value) || getDateFromGeneral(value) || getDateFromMonthStr(value);
  return values ? values.slice(1, 4) : [];
}
function getTimeFromSimple(value) {
  var dateFormat = /^(\d{1})(\d{0,2})([ap]+m*)*$/i;
  if (/\d{4}[\ ]*[ap]*/i.test(value)) {
    dateFormat = /^(\d{2})(\d{1,2})[\ ]*([ap]+m*)*$/i;
  } else if (/^\d{2}$/.test(value)) {
    dateFormat = /^(\d{2})()()$/i;
  }
  return value.match(dateFormat);
}
function getTimeFromGeneral(value) {
  var dateFormat = /^(0?[1-9]|[1][0-9]|2[0-3]+)[\:](0?[1-9]|[0-5]*[0-9]+)[\ ]*([ap]+m*)*$/i;
  return value.match(dateFormat);
}
function getTime(value) {
  var values = getTimeFromSimple(value) || getTimeFromGeneral(value);
  return values ? values.slice(1, 4) : [];
}
export function inferDate(string, date) {
  var _getDate = getDate(string),
    _getDate2 = _slicedToArray(_getDate, 3),
    month = _getDate2[0],
    day = _getDate2[1],
    year = _getDate2[2];
  return new Date(inferYear(year, date), inferMonth(month, date), inferDay(day, date), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
export function inferTime(string, date) {
  var _getTime = getTime(string),
    _getTime2 = _slicedToArray(_getTime, 3),
    hours = _getTime2[0],
    minutes = _getTime2[1],
    amPm = _getTime2[2];
  return {
    hours: inferHours(hours, isPm(amPm, hours), date),
    minutes: inferMinutes(minutes, date)
  };
}
export function toMinutes(_ref2) {
  var hours = _ref2.hours,
    minutes = _ref2.minutes;
  return hours % 24 * 60 + minutes;
}
export function isValidDateFormat(string) {
  var _getDate3 = getDate(string),
    _getDate4 = _slicedToArray(_getDate3, 2),
    month = _getDate4[0],
    day = _getDate4[1];
  if (!month || !day) return false;
  if (isValidInteger(month)) {
    var monthNum = Number(month);
    return monthNum >= 1 && monthNum <= 12;
  }
  if (month.length < 3) return false;
  return true;
}
//# sourceMappingURL=parseDate.js.map